import React, { useState } from 'react'
import SideBar from '../components/SideBar'
import TopBar from '../components/topBar'
import CustomersListCom from '../components/CustomersListCom'
import CreateCategory from '../components/CreateCategory'
import Category from '../components/Category'

function ShowCategory() {
    const [isMenuOpen, setMenuOpen] = useState(false)
    const hideShowMenuClick = () => {
        setMenuOpen(current => !current)
    }
    return (
        <>
            <div className="allPages">
                <SideBar
                    {...{ isMenuOpen, setMenuOpen }}
                />
                <div className="innerBox">
                    <TopBar
                        {...{ hideShowMenuClick }}
                    />
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <Category/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ShowCategory